module.exports = __webpack_public_path__ + "img/xhy.red-150x150.15ef8581.png";